export default {"src":"/_next/static/media/petsitter.2d860c2b.svg","height":46,"width":100,"blurWidth":0,"blurHeight":0};